import type MarketSelectionProperties from './MarketSelection.properties.ts';
import MarketSelectionDesktopView from './desktop/MarketSelection.desktop.view.tsx';
import MarketSelectionMobileView from './mobile/MarketSelection.mobile.view.tsx';
import { useIsDesktopDevice } from '../../tools/hooks/useIsDesktopDevice.ts';
import { useIsMobileDevice } from '../../tools/hooks/useIsMobileDevice.ts';

export default function MarketSelectionView(props: MarketSelectionProperties) {
  const isDesktop = useIsDesktopDevice();
  const isMobile = useIsMobileDevice();

  return (
    <>
      {isMobile && <MarketSelectionMobileView {...props} />}
      {isDesktop && <MarketSelectionDesktopView {...props} />}
    </>
  );
}
